"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTE_GROUPS = void 0;
const FULL_1 = require("./FULL.js");
exports.ROUTE_GROUPS = {
    APP: [
        FULL_1.FULL_ROUTES.DASHBOARD,
        FULL_1.FULL_ROUTES.INITIATIVES,
        FULL_1.FULL_ROUTES.ISSUES,
        FULL_1.FULL_ROUTES.PERISCOPE,
        FULL_1.FULL_ROUTES.SETTINGS,
        FULL_1.FULL_ROUTES.SYNC,
        FULL_1.FULL_ROUTES.TAGS,
        FULL_1.FULL_ROUTES.TIMELINE
    ],
    DASHBOARD: [
        FULL_1.FULL_ROUTES.DASHBOARD,
        FULL_1.FULL_ROUTES.EXPORT
    ],
    INITIATIVES: [
        FULL_1.FULL_ROUTES.INITIATIVES,
        FULL_1.FULL_ROUTES.INITIATIVES_DETAIL
    ],
    ONBOARDING: [
        FULL_1.FULL_ROUTES.ONBOARDING_CONFIRM,
        FULL_1.FULL_ROUTES.ONBOARDING_CONNECT,
        FULL_1.FULL_ROUTES.ONBOARDING_SYNC
    ],
    SETTINGS: [
        FULL_1.FULL_ROUTES.SETTINGS,
        FULL_1.FULL_ROUTES.SETTINGS_INTEGRATIONS,
        FULL_1.FULL_ROUTES.SETTINGS_ORGANIZATION,
        FULL_1.FULL_ROUTES.SETTINGS_TEAM,
        FULL_1.FULL_ROUTES.SETTINGS_USER
    ]
};
//# sourceMappingURL=GROUPS.js.map